<template>
  <table class="table table-hover align-middle">
    <thead class="table-light">
      <tr>
        <th scope="col" style="width: 25px">
          <div class="form-check">
            <input
              style="margin-bottom: 4px"
              v-model="showAllChecked"
              class="form-check-input"
              type="checkbox"
              id="checkAll"
              @change="checkAllChanged($event)"
            />
          </div>
        </th>
        <th scope="col" style="width: 20px">
          <i
            class="ri-arrow-down-s-line"
            style="cursor: pointer"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            v-show="isShowTHstate"
          ></i>
          <div class="dropdown-menu dropdownmenu-info">
            <div
              class="form-check mb-2 ms-2"
              v-for="(state, i) in allStateCheck"
              :key="i"
            >
              <input
                class="form-check-input me-1"
                type="radio"
                name="flexRadioDefault"
                v-model="allState"
                :value="state.value"
                @change="allStateChange($event, state)"
              />
              <label class="form-check-label" for="flexRadioDefault">{{
                state.label
              }}</label>
            </div>
          </div>
        </th>
        <th
          scope="col"
          v-for="th in column"
          :key="th.dataIndex"
          :style="{ width: th.title == this.$t('page.event-management.EventNumber') && '200px' }"
        >
          {{ th.title }}
        </th>
        <th>{{this.$t('base.operation')}}</th>
      </tr>
    </thead>
    <tbody class="list">
      <tr v-for="(item, index) in showTableData" :key="index">
        <th scope="row">
          <div class="form-check">
            <input
              style="margin-bottom: 4px"
              class="form-check-input"
              v-model="item.checked"
              type="checkbox"
              name="chk_child"
              @change="singleChecked($event, item.event_id)"
            />
          </div>
        </th>
        <th scope="row"></th>
        <td>
          <span
            class="link-primary"
            style="cursor: pointer"
            @click="viewDetail(item.id, item)"
            >{{ item.readableNo }}</span
          >
        </td>
        <td>
          {{
            (item.createdAt &&
              moment(item.createdAt).tz($tz).format("YYYY-MM-DD HH:mm:ss")) ||
            "-"
          }}
        </td>
        <td>
          <div style="display: flex; alignitems: center; aligncontent: center">
            <img
              src="@/assets/images/eventtype-warning.svg"
              style="width: auto; height: auto;"
              v-if="
                item.level === 'WARNING' &&
                item.kind != 'TIME_BASED_DYTHRESHOLD_PREDICATE'
              "
            />
            <img
              src="@/assets/images/eventtype-error.svg"
              style="width: auto; height: auto;"
              v-if="item.level === 'ERROR'"
            />
            <img
              src="@/assets/images/eventtype-alarm.svg"
              style="width: auto; height: auto;"
              v-if="
                item.level === 'WARNING' &&
                item.kind === 'TIME_BASED_DYTHRESHOLD_PREDICATE'
              "
            />
            <img
              src="@/assets/images/eventtype-remind.svg"
              style="width: auto; height: auto;"
              v-if="item.level === 'NORMAL'"
            />
            <img
              src="@/assets/images/eventtype-unknown.svg"
              style="width: auto; height: auto;"
              v-if="item.level === 'UNKNOWN'"
            />
            <div
              v-if="
                item.level != 'WARNING' &&
                item.kind != 'TIME_BASED_DYTHRESHOLD_PREDICATE'
              "
              class="ms-1"
              style="margin-top: 2px"
            >
              {{  filterEventType(item.level)||item.name  }}
            </div>
            <div
              v-if="
                item.level === 'WARNING' &&
                item.kind === 'TIME_BASED_DYTHRESHOLD_PREDICATE'
              "
            >
              {{this.$t('page.event-management.IntelligentAlarm')}}
            </div>
            <div
              v-if="
                item.level === 'WARNING' &&
                item.kind != 'TIME_BASED_DYTHRESHOLD_PREDICATE'
              "
            >
              {{this.$t('page.event-management.warning')}}
            </div>
          </div>
        </td>
        <td>{{ item.device_name || "-" }}</td>
        <td>{{ item["root_sn"] || "-" }}</td>
        <td>{{ item["group_sn"] || "-" }}</td>
        <td>{{ item.measure_name }}</td>
        <td>
          {{
            (item.updatedAt &&
              moment(item.updatedAt).tz($tz).format("YYYY-MM-DD HH:mm:ss")) ||
            "-"
          }}
        </td>
        <td>
          <div class="btn-group">
            <span
              :class="[
                'badge',
                item.status === 'PENDING' && 'badge-open',
                item.status === 'PROCESSING' && 'badge-handling',
                item.status === 'WAITING_CONFIRM' && 'badge-waitconfirm',
                item.status === 'CLOSED' && 'badge-closed',
                item.status === 'SCHEDULED' && 'badge-released',
                item.status === 'SOLVED' && 'badge-solved',
                'dropdown-toggle',
              ]"
              style="cursor: pointer"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >{{ filterEventState(item.status) }}</span
            >
            <div class="dropdown-menu dropdownmenu-info">
              <a
                :class="[
                  'dropdown-item',
                  item.status === 'PENDING' && 'active',
                ]"
                href="#"
                @click="stateClick($event, 'PENDING', item)"
                >{{this.$t('page.event-management.start')}}</a
              >
              <a
                :class="[
                  'dropdown-item',
                  item.status === 'PROCESSING' && 'active',
                ]"
                href="#"
                @click="stateClick($event, 'PROCESSING', item)"
                >{{this.$t('page.event-management.BeingProcessed')}}</a
              >
              <a
                :class="[
                  'dropdown-item',
                  item.status === 'WAITING_CONFIRM' && 'active',
                ]"
                href="#"
                @click="stateClick($event, 'WAITING_CONFIRM', item)"
                >{{this.$t('page.event-management.WaitForConfirmation')}}</a
              >
              <a
                :class="['dropdown-item', item.status === 'CLOSED' && 'active']"
                href="#"
                @click="stateClick($event, 'CLOSED', item)"
                >{{this.$t('page.event-management.closed')}}</a
              >
              <a
                :class="[
                  'dropdown-item',
                  item.status === 'SCHEDULED' && 'active',
                ]"
                href="#"
                @click="stateClick($event, 'SCHEDULED', item)"
                >{{this.$t('page.event-management.HavePublished')}}</a
              >
              <a
                :class="['dropdown-item', item.status === 'SOLVED' && 'active']"
                href="#"
                @click="stateClick($event, 'SOLVED', item)"
                >{{this.$t('page.event-management.resloved')}}</a
              >
            </div>
          </div>
        </td>
        <td>
          <ul class="list-inline hstack gap-2 mb-0">
            <template v-for="(icon, iconIndex) in actionIcon" :key="iconIndex">
              <li
                class="list-inline-item"
                @click="handleAction(item, icon.type)"
              >
                <span :class="['d-inline-block', `text-${icon.textType}`]">
                  <i :class="['fs-16', icon.iconClass]"></i>
                </span>
              </li>
            </template>
          </ul>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { eventTypeList, eventStateList } from "@/utils/selectText.js";
import moment from "moment";
import "moment-timezone";
export default {
  emits: [
    "update:singleData",
    "checkAllChanged",
    "singleChecked",
    "getEventsDetailInfo",
    "changeStatus",
    "changeMoreStatus",
  ],
  props: {
    singleData: Object,
    allChecked: Boolean,
    actionIcon: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    column: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      showTableData: [],
      showAllChecked: false,
      allStateCheck: eventStateList,
      allState: null,
      isShowTHstate: false,
    };
  },
  computed: {},
  watch: {
    allChecked: {
      handler(newVal) {
        this.showAllChecked = newVal;
      },
      deep: true,
      immediate: true,
    },
    tableData: {
      handler(newVal) {
        this.showTableData = newVal;
      },
      deep: true,
      immediate: true,
    },
    showTableData: {
      handler(newVal) {
        if (!newVal.length) return;
        this.isShowTHstate = newVal.some((item) => {
          return item.checked;
        });
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    moment,
    filterEventType(val) {
      let info = eventTypeList.find((item) => {
        return item.value === val;
      });
      if (info) {
        return info.label;
      }
    },
    filterEventState(val) {
      let info = eventStateList.find((item) => {
        return item.value === val;
      });
      if (info) {
        return info.label;
      }
    },
    checkAllChanged() {
      this.$emit("checkAllChanged", this.showAllChecked);
    },
    singleChecked(ev, id) {
      this.$emit("singleChecked", id, ev.target.checked);
    },
    viewDetail(id, item) {
      let deviceInfo = {
        measure_name: item.measure_name,
        measure_key: item.measure_key,
        suggestion: item.suggestion,
        instruction: item.instruction,
        deviceId: item.deviceId,
        device_name: item.device_name,
        设备所在区域: item['设备所在区域'],
        机组名称: item['机组名称'],
        measure_info: item.measure_info,
      };
      this.$emit("getEventsDetailInfo", id, deviceInfo);
    },
    handleAction(event, iconType) {
      switch (iconType) {
        case "view":
          this.viewDetail(event.id, event);
          break;
        case "delete":
          break;
      }
    },
    stateClick(ev, state, data) {
      let ele = ev.currentTarget.parentElement;
      if (ele && ele.classList.contains("show")) {
        ele.classList.remove("show");
      }
      this.$emit("changeStatus", state, data);
    },
    allStateChange(ev, state) {
      let ele = ev.currentTarget.parentElement;
      if (ele && ele.parentNode && ele.parentNode.classList.contains("show")) {
        setTimeout(() => {
          ele.classList.remove("show");
          this.allState = null;
        }, 1000);
      }
      this.$emit("changeMoreStatus", state.value);
    },
  },
};
</script>

<style lang="scss">
.badge-open {
  color: #3577f1;
  background: rgba(53, 119, 241, 0.1);
}
.badge-handling {
  color: #50c3e6;
  background: rgba(80, 195, 230, 0.1);
}
.badge-waitconfirm {
  color: #865ce2;
  background: rgba(134, 92, 226, 0.1);
}
.badge-closed {
  color: #212529;
  background: rgba(236, 156, 98, 0.1);
}
.badge-released {
  color: #13c56b;
  background: rgba(19, 197, 107, 0.1);
}
.badge-solved {
  color: #6691e7;
  background: rgba(64, 81, 137, 0.1);
}
</style>
